<template>
<!-- 询价管理 -->
<section class="viewContainer">
  <div v-show="isOrder" @listenEdit="showOrder">
    <!-- 搜索/查询 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <el-collapse-transition>
        <div v-show="show3">
          <el-form :inline="true" :model="filters" class="findform">
            <!-- 顶部搜索框 -->
            <el-form-item style="display:flex;width:30%" label="询价单号：">
              <el-input v-model="filters.EnterpriseName" placeholder="请输入询价单号" maxlength="20" style="width: 90%;"/>
            </el-form-item>
            <el-form-item style="display:flex;width:30%" label="询价时间：">
              <el-date-picker v-model="filters.partnerRegion" type="daterange" value-format="yyyy-MM-dd" @change="hdsjTime"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 90%;"/>
            </el-form-item>
            <el-form-item style="display:flex;width:30%" label="用户手机：">
              <el-input v-model="filters.partnerPhone" placeholder="请输入手机号" maxlength="11" style="width: 90%;"/>
            </el-form-item>
            <!-- <el-form-item style="display:flex;width:25%;" label="性质：">
              <el-select v-model="filters.partnerGender" filterable placeholder="请选择" style="background:#fff;width:100%">
                <el-option v-for="(item,index) in genderArr" :key="index" :label="item.Name" :value="item.Id" />
              </el-select>
            </el-form-item> -->
            <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <!--列表-->
    <div class="main_container">
      <section class="model_section">
        <el-col :span="18"> <p class="model_top_title">客户询价单</p> </el-col>
      </section>
      <!-- table 列表 -->
      <div class="table_container">
        <el-table :data="dataList" stripe border>
          <el-table-column label="序号" align="center" width="60">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column label="询价单号" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.newInquiryNo">{{scope.row.newInquiryNo}}</span>
            </template>
          </el-table-column>
          <el-table-column label="询价时间" align="center"> <template scope="scope">{{scope.row.cTime}}</template> </el-table-column>
          <el-table-column label="询价类型" align="center"> <template scope="scope">{{scope.row.inquiryType}}</template> </el-table-column>
          <el-table-column label="所在城区" align="center"> <template scope="scope">{{scope.row.address}}</template> </el-table-column>
          <el-table-column label="房屋面积（㎡）" align="center"> <template scope="scope">{{scope.row.housingArea}}</template> </el-table-column>
          <el-table-column label="房屋户型" align="center"> <template scope="scope">{{scope.row.house}}</template> </el-table-column>
          <el-table-column label="询价品类（类型）" align="center"> <template scope="scope">{{scope.row.type}}</template> </el-table-column>
          <el-table-column label="预算(元)" align="center"> <template scope="scope">{{scope.row.budget}}</template> </el-table-column>
          <el-table-column label="用户手机" align="center"> <template scope="scope">{{scope.row.phone}}</template> </el-table-column>
          <el-table-column label="操作" fixed="right" align="center">
            <template scope="scope">
              <el-button type="text" @click="cliSeePartner(scope.row, 1)" size="small" v-show="scope.row.state">报价</el-button>
              <span @click="cliSeePartner(scope.row, 2)" class="handle" v-show="!scope.row.state"> <i class="el-icon-view"/>查看</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
        :current-page="pageIndex" :page-size="10" :total="totalRowsCount" style="float:right;margin:10px 0;"/>
      </div>
    </div>
  </div>

  <section class="main_container" v-show="seeDetails">
    <section class="model_section">
      <p class="model_top_title">询价详情</p>
      <!-- <el-button type="danger" @click="showOrder()" style="float: right;margin: 5px 10px 0 0;">返回</el-button> -->
    </section>
    <div class="watch_msg">
      <p class="typefaceOne">{{newData.phone}} 用户的询价信息<span v-show="newData.endTime!='已结束'">询价截止：{{newData.endTime}}</span><span style="color: #FF6666;" v-show="newData.endTime=='已结束'">询价截止：{{newData.endTime}}</span></p>
      <el-row class="elRow">
        <el-col class="elCol">
          <div class="elGroup"> <el-button class="btnGroup">询价类型 :</el-button> {{newData.inquiryType}} </div>
          <div class="elGroup"> <el-button class="btnGroup">房屋面积 :</el-button> {{newData.housingArea}}  ㎡ </div>
          <div class="elGroup"> <el-button class="btnGroup">装修风格 :</el-button> {{newData.style}} </div>
          <div class="elGroup"> <el-button class="btnGroup">预算范围 :</el-button> {{newData.budget}} </div>
          <div class="elGroup"> <el-button class="btnGroup">小区名称 :</el-button> {{newData.residentialQuartersName}} </div>
        </el-col>
        <el-col class="elCol">
          <div class="elGroup"> <el-button class="btnGroup">所在城区 :</el-button> {{newData.address}} </div>
          <div class="elGroup"> <el-button class="btnGroup">房屋户型 :</el-button> {{newData.house}} </div>
          <div class="elGroup" :title="newData.type"> <el-button class="btnGroup">{{newData.inquiryTypeId == 1?'询价品类':'装修类型'}} :</el-button> {{newData.type}} </div>
          <div class="elGroup" v-show="newData.inquiryTypeId == 1"> <el-button class="btnGroup">意向品牌 :</el-button> {{newData.brand}} </div>
          <div class="elGroup" v-show="newData.inquiryTypeId == 1"> <el-button class="btnGroup">购买数量 :</el-button> {{newData.purchaseNumber}} </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <div style="margin-bottom: 20px;margin-left: 20px;" v-show="newData.houseTypeImgs && newData.houseTypeImgs.length>0">
            <el-button class="btnGroup" style="border: 1px solid #e5e5e5;">户型图片 :</el-button>
            <span v-for="(itemImg, index) in newData.houseTypeImgs" :key='index'>
              <el-image :src="itemImg" class="threeImg" :preview-src-list="[itemImg]" @click="handleClickItem"/>
            </span>
          </div>
          <div style="margin-bottom: 20px;margin-left: 20px;" v-show="newData.inquiryTypeId == 1">
            <el-button class="btnGroup" style="border: 1px solid #e5e5e5;">建材图片 :</el-button>
            <span v-for="(itemImg, index) in newData.buildingMaterialImgs" :key='index'>
              <el-image :src="itemImg" class="threeImg" :preview-src-list="[itemImg]" @click="handleClickItem"/>
            </span>
          </div>
          <div style="margin-bottom: 20px;margin-left: 20px;" v-show="newData.inquiryTypeId == 2">
            <el-button class="btnGroup" style="border: 1px solid #e5e5e5;">参考图片 :</el-button>
            <span v-for="(itemImg, index) in newData.referenceImgs" :key='index'>
              <el-image :src="itemImg" class="threeImg" :preview-src-list="[itemImg]" @click="handleClickItem"/>
            </span>
          </div>
          <!-- <div class="elGroup" style="width:43.6%"> <el-button class="btnGroup">备注 :</el-button> {{newData.remark}} </div> -->
          <div>
            <div class="elGroup" style="width: 43.5%;"> <el-button class="btnGroup">询价备注 :</el-button> {{newData.remark}} </div>
          </div>
        </el-col>
      </el-row>
      
      <p class="typefaceTwo">报价信息<span style="color: #FF6666;">温馨提示：您的报价如果客户有购买意向，用户的手机号码会全部显示</span></p>
      <el-row class="elRowBjxx">
        <el-col :span="22">
          <div style="margin-bottom: 20px;">
            <el-button class="dropDown">{{newData.inquiryTypeId == 1?'竞标品牌':'竞标类型'}} :</el-button>
            <el-select v-model="biddingBrand" filterable placeholder="请选择" :disabled="!seeSub" style="width:28%" @change="changeBidding">
              <el-option v-for="(item,index) in brandArr" :key="index" :label="item.name" :value="item.id"/>
            </el-select>
            <span style="margin-left: 16px;" v-show="newData.inquiryTypeId == 1 && ordinaryRate">
              普通让利 : <b style="color: #FF6666;">{{ordinaryRate}}%</b>
              特价让利 : <b style="color: #FF6666;">{{promotionRate}}%</b>
            </span>
            <span style="margin-left: 16px;" v-show="newData.inquiryTypeId == 2 && ordinaryRate">
              让利 : <b style="color: #FF6666;">{{ordinaryRate}}%</b>
            </span>
          </div>
          <div>
            <el-input v-model="biddingPrice" placeholder="请输入竞标价格" maxlength="21" disabled="!seeSub"
            onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" style="width: 35%; margin-bottom: 20px; margin-right: 15px;">
              <template slot="prepend">竞标价格 :</template>
              <i slot="suffix" style="margin-right: 10px;line-height: 36px;">元</i>
            </el-input>
            <span style="color: #FF6666;">重要提示：竞标价格请填写未让利前的价格</span>
          </div>
          
          <div style="margin-bottom: 20px;">
            <el-button class="btnGroup" style="border: 1px solid #e5e5e5;float:left;">说明图片 :</el-button>
            <div class="upPictures">
              <div class="multigraph" v-for="(item,index) in detailImgUrlarr" :key="index" :data-img="item">
                <el-image :src="item" :preview-src-list="[item]" @click="handleClickItem"
                style="width: 80px;height:80px;"/>
                <div class="chahao" @click.stop="deldetail(index)" v-show="seeSub"> <img src="../../assets/img/aicon36.png"/> </div>
              </div>
              <!-- 上传图片 -->
              <el-upload action multiple v-if="flag < 10" :before-upload="beforeAvatarUpload" accept=".png, .jpg,.jpeg">
                <i class="el-icon-plus upBtn" v-if="seeSub"></i>
              </el-upload>
              <p class="spPicWenan">支持JPG,PNG格式图片，最多支持上传10张。</p>
            </div>
          </div>
          <div>
            <el-button class="beizhu">报价备注 :</el-button>
            <el-input type="textarea" :rows="2" v-model="remarks" maxlength="500" placeholder="请输入备注"
            style="width: 28%;" :disabled="!seeSub"/>
          </div>
        </el-col>
      </el-row>
    </div>
    
    <div class="gudingdibu">
      <el-button @click="showOrder()">{{ seeSub?'取消':'返回' }}</el-button>
      <el-button type="danger" @click="btnSubmit()" v-show="seeSub">确定</el-button>
    </div>
  </section>

  <!-- 请选择店铺 -->
  <el-dialog :center="true" title="请选择店铺" :visible.sync="dialogVisibleadd" width="25%">
    <el-form class="findform">
      <el-form-item label="店铺名称：" style="display:flex;">
        <el-select v-model="bbid" filterable placeholder="请选择店铺">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
  
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getOssFile, userIdentity } from '../../api/newOss';
import { getBackList, getBackDetails, getBackQuoteType, postBack } from "../../api/comment";
export default {
  name: 'askForLowPrice', // 询价管理
  mixins: [alertTrends],
  data() {
    return {
      show3: true, // 查询区域默认展开
      isOrder: true, // 列表页
      seeDetails: false, // 查看
      seeSub: false,

      filters: {
        EnterpriseName: "", // 询价单号
        partnerRegion: "", // 询价时间
        ksTime: "", // 开始时间
        jsTime: "", // 结束时间
        partnerPhone: "", // 手机号
        // partnerGender: 0, // 性质
      },
      genderArr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "企业"
        },
        {
          Id: 2,
          Name: "个人"
        }
      ],
      
      dataList: [], // 列表data
      peopleId: "", // 询价单id
      pageIndex: 1,
      totalRowsCount: 0,
      newData: {}, // 详情页
      newQuote: {}, // 报价数据
      quotationId: '', // 报价单id
      biddingBrand: '', // 竞标品牌
      brandArr: [],
      ordinaryRate: '', // 普通让利
      promotionRate: '', // 特价让利
      biddingType: 1, // 竞标品牌 & 竞标类型
      biddingPrice: '', // 竞标价格
      detailImgUrlarr: [], // 说明图片-多图集合
      flag: 0,
      remarks: '', // 备注
      
      bbid:'',  // 店铺id
      options1: [],
      dialogVisibleadd: false, // 询价管理-弹框
    }
  },
  methods: {
    // 显示主页
    showOrder() {
      this.isOrder = true; // 主页
      this.seeDetails = false; // 详情页
    },
    // 询价时间
    hdsjTime(time) {
      this.filters.ksTime = time[0];
      this.filters.jsTime = time[1];
    },
    // 查询列表
    init() {
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      let addParams = {
        bbid: this.bbid, // 店铺id
        orderNo: this.filters.EnterpriseName, // 询价单号
        beginDate: this.filters.ksTime, // 开始时间（格式：yyyy-MM-dd）
        endDate: this.filters.jsTime, // 结束时间（格式：yyyy-MM-dd）
        phone: this.filters.partnerPhone, // 手机号
        // enterpriseAttribute: this.filters.partnerGender, // 性质：0全部、1企业、2个人
        pageIndex: this.pageIndex,// 页码
        pageSize: 10 // 每页行数
      };
      getBackList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.dataList = data.resultObj.resultObj;
            this.totalRowsCount = data.resultObj.rowsCount;
          } else {
            this.dataList = [];
            this.totalRowsCount = 0;
          }
        } else {
          this.dataList = [];
          this.totalRowsCount = 0;
        }
      })
    },
    // 竞标品牌&竞标类型
    changeBidding(val){
      this.brandArr.filter(item => {
        if(item.id == val){
          this.ordinaryRate = item.ordinaryRate; // 普通让利
          this.promotionRate = item.promotionRate; // 特价让利
        }
      })
    },
    // 报价 & 查看
    cliSeePartner(row, type) {
      this.peopleId = row.id; // 询价单id
      this.isOrder = false; // 主页
      this.seeDetails = true; // 详情页
      this.ordinaryRate = ''; // 普通让利
      this.promotionRate = ''; // 特价让利
      this.jbpp(); // 竞标品牌
      if(type == 1) {
        this.seeSub = true;
        this.biddingBrand = '';
        this.biddingPrice = '';
        this.remarks = '';
        this.detailImgUrlarr = [];
        this.flag = 0;
      } else {
        this.seeSub = false;
      }
      var addParams = {
        id: this.peopleId, // 询价单id
        bbid: this.bbid // 店铺id
      };
      getBackDetails(addParams).then(data => {
        if(data.resultCode == 1) {
          this.newData = data.resultObj.data; // 询价单详情数据
          this.newQuote = data.resultObj.quote; // 报价数据
          if(this.newQuote) {
            this.quotationId = this.newQuote.id; // 报价单id
            this.biddingBrand = this.newQuote.typeId; // 竞标品牌id
            this.biddingType = this.newQuote.inquiryType; // 报价类型  1=建材、2=装修
            this.ordinaryRate = this.newQuote.ordinaryRate; // 普通让利（无%号，装修报价显示普通让利）
            this.promotionRate = this.newQuote.promotionRate; // 特价让利（无%号）
            // this.biddingPrice = this.newQuote.price + ' 元'; // 竞标价格
            this.biddingPrice = this.newQuote.price; // 竞标价格
            this.remarks = this.newQuote.remark; // 备注
            this.detailImgUrlarr = this.newQuote.imgs; // 说明图片集合
          }
        }
      })
    },
    // 确定报价
    btnSubmit() {
      if (this.biddingBrand == '') {
        this.showAlert(this.newData.inquiryTypeId == 1?'竞标品牌必选':'竞标类型必选');
        return false;
      }
      if (this.biddingPrice == '') {
        this.showAlert('请输入竞标价格');
        return false;
      }
      if (this.detailImgUrlarr.length == 0) {
        this.showAlert('请上传说明图片');
        return false;
      }
      let addParams = {
        bbId: this.bbid, // 店铺id
        userId: localStorage.Id, // 用户id
        inquiryId: this.peopleId, // 询价单id
        typeId: this.biddingBrand, // 竞标品牌（类型）Id
        price: this.biddingPrice, // 竞标价格
        remark: this.remarks, // 备注
        imgs: this.detailImgUrlarr.map(item => item.replace(localStorage.BaseOssUrl, '')), // 说明图片集合
      }
      postBack(addParams).then(data => {
        if(data.resultCode == 1) {
          this.showAlert(data.resultMsg, 'success');
          this.isOrder = true; // 主页
          this.seeDetails = false; // 详情页
          this.init();
        } else {
          this.showAlert(data.resultMsg);
        }
      })
    },
    // 多图上传
    beforeAvatarUpload(file) {
      // 判断图片格式
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' ||file.type === 'image/jpeg';
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 1;
      if (!isJPG) {
        this.showAlert('上传图片只支持jpg、png等格式');
        return;
      }
      if (!isLt2M) {
        this.showAlert('上传图片大小不能超过 1MB');
        return;
      }
      this.flag += 1;
      if (this.flag > 10) {
        this.showAlert('最多传入10张图片');
        return false;
      }
      var _this = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(e) {
        // oss 直传图片
        let obj = {
          type: 9
        };
        getOssFile(obj).then(data => {
          if (data.resultCode == 1) {
            let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
            let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
            let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
            let ossfile = data.resultObj.directory; // 保存路径
            let ossbucket = data.resultObj.bucket; // bucket
            localStorage.setItem('keyossId',ossId);
            localStorage.setItem('keyossSecret',ossSecret);
            localStorage.setItem('keyossHost',ossHost);
            localStorage.setItem('keyossfile',ossfile);
            localStorage.setItem('keyossbucket',ossbucket);
            
            uploadOSS(file,0).then(data => {
              var newOssPic = data;
              // _this.detailImgUrlarr.push({picUrl:newOssPic})
              _this.detailImgUrlarr.push(newOssPic);
            })
            
          }
        })
      };
    },
    // 删除上传图片
    deldetail(val) {
      let newdetailImgUrlarr = this.detailImgUrlarr;
      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        if (val == i) {
          newdetailImgUrlarr.splice(i, 1);
        }
      }
      this.detailImgUrlarr = newdetailImgUrlarr;
      this.flag = this.detailImgUrlarr.length;
    },
    // 重置
    fnReset() {
      this.filters = {
        EnterpriseName: "", // 询价单号
        partnerRegion: "", // 询价时间
        partnerPhone: "", // 手机号
        // partnerGender: 0, // 性质
      }
      // this.pageIndex = 1;
      // this.init();
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.init();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },
    
    // 获取竞标品牌（类型）
    jbpp(){
      let addParams = {
        bbid: this.bbid, // 店铺id
      };
      getBackQuoteType(addParams).then(data => {
        if (data.resultCode == 1) {
          this.brandArr = data.resultObj.list;
        }
      })
    },
    
    // 获取用户身份
    handleUserId(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if(data.resultObj.length>1){
              this.dialogVisibleadd = true;
              this.options1 = data.resultObj;
            } else { // 默认选中第一个店铺不显示弹框
              this.dialogVisibleadd = false;
              this.bbid = data.resultObj[0].id; // 店铺id
              this.gonext();
            }
            
          }
        }
      })
    },
    // 确定
    gonext(){
      if(this.bbid == ""){
        this.showAlert('请选择店铺名称');
        return false;
      }
      this.init(); // 查询列表
      this.dialogVisibleadd = false;
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
  },
  created() {
    this.handleUserId();    // 获取用户身份
  }
}
</script>
<style scoped>
/* 基本信息 */
.watch_msg {
  width: 96%;
  margin: 0 auto;
  margin-bottom: 50px;
}
.typefaceOne {
  width: 98%;
  margin: 20px auto;
  font-size: 15px;
  font-weight: bold;
  line-height: 33px;
}
.typefaceOne>span {
  font-size: 13px;
  border-bottom: 1px solid #eee;
  width: 78%;
  display: inline-block;
  text-align: right;
  padding-right: 20px;
}
.typefaceTwo {
  width: 98%;
  margin: 0 auto;
  font-size: 15px;
  font-weight: bold;
  line-height: 33px;
}
.typefaceTwo>span {
  font-size: 12px;
  padding: 0 30px 5px 30px;
  border-bottom: 1px solid #eee;
}
.elRow {
  width: 100%;
  margin: 0 auto;
  display: flex;
}
.elCol {
  width: 50%;
}
.elGroup {
  width: 80%;
  height: 38px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  margin-bottom: 20px;
  margin-left: 20px;

  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow:ellipsis;
  
}
.btnGroup {
  border: none;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  background-color: #F5F7FA;
  color: #909399;
  margin-right: 20px;
}
/* 竞标品牌 */
.dropDown {
  border: 1px solid #DCDFE6;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  background-color: #F5F7FA;
  color: #909399;
  margin-right: -3px;
}

/* 报价信息 */
.elRowBjxx {
  width: 98%;
  margin: 20px auto;
}
.singleRow {
  width: 50%;
  margin-bottom: 20px;
}

/* 多图 */
.upPictures {
  width: 88%;
  float: left;
}
.multigraph {
  width: 80px;
  height: 80px;
  position: relative;
  float:left;
  margin-right:10px;
  margin-bottom: 5px;
}
.upBtn {
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #DCDFE6;
  font-size: 26px;
  color: #999;
}
.spPicWenan {
  width: 100%;
  height: 30px;
  display: inline-block;
  margin: 5px auto;
  color: #999;
}
.threeImg {
  width: 86px;
  height: 86px;
  margin-right: 10px;
  border-radius: 3px;
  cursor: pointer;
}
/* 备注 */
.beizhu {
  float: left;
  border: none;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  background-color: #F5F7FA;
  color: #909399;
  border: 1px solid #eee;
  margin-right: -1px;
}
</style>


// WEBPACK FOOTER //
// askForLowPrice.vue?838edea6